export default "__VITE_ASSET__JWBVIFU2__"